<form [formGroup]="searchForm">
  <mat-card>
    <div formGroupName="inspectionData">
      <!-- Filters related to inspections -->
      <div class="permanent-filters">
        <button
          matTooltip="Blende weitere Filter auf Inspektionsebene {{
            expandInspectionFilters ? 'aus' : 'ein'
          }}"
          mat-stroked-button
          color="primary"
          (click)="toggleInspectionFilters()"
          [ngStyle]="{
            'background-color': isAnyInspectionFilterSet
              ? '#bcdef7'
              : 'transparent'
          }"
        >
          <mat-icon>{{
            expandInspectionFilters ? 'expand_more' : 'expand_less'
          }}</mat-icon>
          Inspektion
        </button>

        <backoffice-numberfield-filter
          style="width: 165px"
          formControlName="inspectionNumber"
          label="Inspektionsnummer"
          suggestionField="inspectionNumber"
          [cognitiveSearchIndex]="inspectionIndex"
        >
        </backoffice-numberfield-filter>
        <backoffice-textfield-filter
          style="width: 300px"
          formControlName="customer"
          label="Auftraggeber"
          suggestionField="customer/name"
          [cognitiveSearchIndex]="inspectionIndex"
        ></backoffice-textfield-filter>
        <backoffice-textfield-filter
          style="width: 300px"
          formControlName="location"
          label="Standort"
          suggestionField="location/name"
          [cognitiveSearchIndex]="inspectionIndex"
        ></backoffice-textfield-filter>
        <backoffice-status
          style="width: 170px"
          *ngIf="showStatus"
          formControlName="status"
          label="Inspektionsstatus"
        ></backoffice-status>
        <backoffice-status-hygiene
          style="width: 210px"
          *ngIf="showStatus"
          formControlName="statusHygiene"
          label="Hygiene-Inspektionsstatus"
        ></backoffice-status-hygiene>
        <backoffice-textfield-filter
          style="width: 260px"
          formControlName="inspectors"
          label="Inspekteur"
          suggestionField="inspectors"
          [cognitiveSearchIndex]="inspectionIndex"
        ></backoffice-textfield-filter>
      </div>

      <div [hidden]="!expandInspectionFilters">
        <div class="hidable-filters">
          <backoffice-textfield-filter
            style="width: 250px"
            formControlName="operator"
            label="Anlagennutzer"
            suggestionField="operator/name"
            [cognitiveSearchIndex]="inspectionIndex"
          ></backoffice-textfield-filter>
          <backoffice-date
            formControlName="startAfterDate"
            label="Startdatum von"
          ></backoffice-date>
          <backoffice-date
            formControlName="startBeforeDate"
            label="Startdatum bis"
          ></backoffice-date>
          <backoffice-date
            formControlName="endAfterDate"
            label="Enddatum von"
          ></backoffice-date>
          <backoffice-date
            formControlName="endBeforeDate"
            label="Enddatum bis"
          ></backoffice-date>
          <backoffice-date
            *ngIf="showDueDates"
            formControlName="dueFromDate"
            label="Wiederholung von"
          ></backoffice-date>
          <backoffice-date
            *ngIf="showDueDates"
            formControlName="dueUntilDate"
            label="Wiederholung bis"
          ></backoffice-date>
          <backoffice-numberfield-filter
            style="width: 140px"
            *ngIf="showAggregateNumberFields"
            formControlName="numberOfAggregates"
            label="Anzahl Anlagen"
          >
          </backoffice-numberfield-filter>
        </div>
      </div>
    </div>

    <div formGroupName="aggregateData">
      <!-- Filters related to aggregates -->
      <div class="permanent-filters">
        <button
          matTooltip="Blende weitere Filter auf Anlagenebene {{
            expandAggregateFilters ? 'aus' : 'ein'
          }}"
          mat-stroked-button
          color="primary"
          (click)="toggleAggregateFilters()"
          [ngStyle]="{
            'background-color': isAnyAggregateGeneralFilterSet
              ? '#bcdef7'
              : 'transparent'
          }"
        >
          <mat-icon>{{
            expandAggregateFilters ? 'expand_more' : 'expand_less'
          }}</mat-icon>
          Anlage
        </button>

        <backoffice-textfield-filter
          style="width: 200px"
          formControlName="name"
          label="Anlagenname"
          suggestionField="name"
          [cognitiveSearchIndex]="aggregateIndex"
        >
        </backoffice-textfield-filter>
        <backoffice-numberfield-filter
          style="width: 175px"
          formControlName="atwId"
          label="ATW-ID"
          suggestionField="atwId"
          [cognitiveSearchIndex]="aggregateIndex"
        >
        </backoffice-numberfield-filter>
        <backoffice-numberfield-filter
          style="width: 140px"
          formControlName="reportPdfId"
          label="Berichtsnummer"
          suggestionField="reportPdfId"
          [cognitiveSearchIndex]="aggregateIndex"
        >
        </backoffice-numberfield-filter>
        <backoffice-aggregate-type
          style="width: 200px"
          formControlName="type"
          label="Typ"
        ></backoffice-aggregate-type>
        <backoffice-aggregate-sub-type
          style="width: 200px"
          formControlName="subType"
          label="Sub-Typ"
        >
        </backoffice-aggregate-sub-type>
      </div>
      <div [hidden]="!expandAggregateFilters">
        <div class="hidable-filters">
          <backoffice-aggregate-shutdown
            style="width: 90px"
            formControlName="shutdown"
            label="Aktiv"
          ></backoffice-aggregate-shutdown>
          <backoffice-textfield-filter
            style="width: 190px"
            formControlName="equipmentNumber"
            label="Equipment-Nummer"
            suggestionField="equipmentNumber"
            [cognitiveSearchIndex]="aggregateIndex"
          >
          </backoffice-textfield-filter>
          <backoffice-textfield-filter
            style="width: 190px"
            formControlName="building"
            label="Gebäude"
            suggestionField="building"
            [cognitiveSearchIndex]="aggregateIndex"
          >
          </backoffice-textfield-filter>
          <backoffice-textfield-filter
            style="width: 190px"
            formControlName="floor"
            label="Stockwerk"
            suggestionField="floor"
            [cognitiveSearchIndex]="aggregateIndex"
          >
          </backoffice-textfield-filter>
          <backoffice-textfield-filter
            style="width: 190px"
            formControlName="installationSite"
            label="Aufstellungsort"
            suggestionField="installationSite"
            [cognitiveSearchIndex]="aggregateIndex"
          >
          </backoffice-textfield-filter>
        </div>
      </div>
    </div>

    <div formGroupName="hygieneAggregateData">
      <!-- Filters related to hygiene data of aggregates -->
      <div class="permanent-filters">
        <button
          matTooltip="Blende weitere hygienespezifische Filter auf Anlagenebene {{
            expandHygieneAggregateFilters ? 'aus' : 'ein'
          }}"
          mat-stroked-button
          color="primary"
          (click)="toggleHygieneAggregateFilters()"
          [ngStyle]="{
            'background-color': isAnyAggregateHygieneFilterSet
              ? '#bcdef7'
              : 'transparent'
          }"
        >
          <mat-icon>{{
            expandHygieneAggregateFilters ? 'expand_more' : 'expand_less'
          }}</mat-icon>
          Hygieneinsp.
        </button>
        <backoffice-aggregate-inspection-type
          style="width: 200px"
          formControlName="inspectionType"
          label="Inspektionstyp"
        ></backoffice-aggregate-inspection-type>
        <backoffice-textfield-filter
          formControlName="inspector"
          label="Inspekteur"
          suggestionField="hygieneData/inspector"
          [cognitiveSearchIndex]="aggregateIndex"
        >
        </backoffice-textfield-filter>
        <backoffice-aggregate-shutdown
          style="width: 140px"
          formControlName="shutdown"
          label="Prüfpflichtig"
        ></backoffice-aggregate-shutdown>
        <backoffice-checkbox-filter
          formControlName="isMostRecent"
          label="Nur letzte Inspektionen"
        ></backoffice-checkbox-filter>
      </div>

      <div [hidden]="!expandHygieneAggregateFilters">
        <div class="hidable-filters">
          <backoffice-date
            formControlName="inspectionDateFrom"
            label="Inspektion von"
          ></backoffice-date>
          <backoffice-date
            formControlName="inspectionDateTo"
            label="Inspektion bis"
          ></backoffice-date>
          <backoffice-date
            style="width: 170px"
            formControlName="nextInspectionDateFrom"
            label="Wiederholung von"
          ></backoffice-date>
          <backoffice-date
            style="width: 170px"
            formControlName="nextInspectionDateTo"
            label="Wiederholung bis"
          ></backoffice-date>
        </div>
      </div>
    </div>

    <!-- Buttons at the bottom of the search -->
    <div class="searchbar-buttons">
      <button
        matTooltip="Filter erneut anwenden"
        mat-stroked-button
        color="primary"
        (click)="refresh()"
      >
        <mat-icon>refresh</mat-icon> aktualisieren
      </button>
      <button
        matTooltip="Suchfelder zurücksetzen"
        mat-stroked-button
        color="primary"
        (click)="reset()"
      >
        <mat-icon>replay</mat-icon> zurücksetzen
      </button>
    </div>
  </mat-card>
</form>
